import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  addRow: {
    display: 'grid',
    gridTemplateColumns: '32px 50px 1fr 90px 90px 80px',
    alignItems: 'center',
    padding: theme.spacing(0.75, 1),
    borderRadius: 4,
    border: `1.5px dashed ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.grey[50],
  },
  idCell: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  nameInput: {
    width: '100%',
    fontSize: 13,
    padding: '4px 6px',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
    outline: 'none',
    fontFamily: 'inherit',
    '&:focus': {
      borderColor: theme.palette.primary.main,
    },
  },
  actionsCell: {
    display: 'flex',
    gap: 2,
    justifyContent: 'flex-end',
  },
  actionBtn: {
    padding: 4,
  },
}))

export default useStyles
